import {
  ref,
  watch,
} from 'vue';

export const useResolutions = () => {
  const isExtraMobile = ref(false);
  const isNormalMobile = ref(false);
  const isMobile = ref(false);
  const isMobileInclusive = ref(false);
  const isTabletBigInclusive = ref(false);
  const isDesktop = ref(false);
  const isTablet = ref(false);
  const width = ref(window.innerWidth);

  window.addEventListener('resize', () => {
    width.value = window.innerWidth;
  });

  watch(width, currentWidth => {
    isExtraMobile.value = currentWidth <= 360;
    isNormalMobile.value = currentWidth <= 375;
    isMobile.value = currentWidth < 768;
    isMobileInclusive.value = currentWidth <= 768;
    isTabletBigInclusive.value = currentWidth <= 992;
    isTablet.value = currentWidth >= 768 && currentWidth < 1150;
    isDesktop.value = !isMobile.value && !isTablet.value;
  }, { immediate: true });

  return {
    isExtraMobile,
    isNormalMobile,
    isMobile,
    isMobileInclusive,
    isTabletBigInclusive,
    isDesktop,
    isTablet,
  };
};
